import { useState, useEffect } from "react";
import { backendURL } from "../Globals";
import { Table, Input, Button, Card, Alert } from 'antd';
import { SearchOutlined, ArrowUpOutlined, DownloadOutlined } from '@ant-design/icons';
import Select from 'react-select';
import { saveAs } from 'file-saver'; // Importa la librería file-saver

const SearchComponent = ({ onSearch }) => {
  const [query, setQuery] = useState('');
  const [area, setArea] = useState('');
  const [quarterJCR, setQuarterJCR] = useState('');
  const [quarterSJR, setQuarterSJR] = useState('');
  const [editor, setEditor] = useState('');
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [alertVisible, setAlertVisible] = useState(true); // Nuevo estado para controlar la visibilidad del Alert
  

  let [issn, setIssn] = useState("");
  let [cuartil, setCuartil] = useState([]);
  let [medida, setMedida] = useState([]);
  let [field, setField] = useState(null);
  let [jcrq, setJcrq] = useState(null);
  let [sjrq, setSjrq] = useState(null);
  let [publisher, setPublisher] = useState([]);
  let [journals, setJournals] = useState([]);
  let [message, setMessage] = useState("");

  const [editors, setEditors] = useState([]); // Estado para almacenar los editores dinámicos

useEffect(() => {
  const fetchEditors = async () => {
    try {
      const response = await fetch(`${backendURL}/journals/publishers`);
      if (!response.ok) throw new Error("Error al obtener los editores");
      const data = await response.json();
      setEditors(data); // Guardar editores en el estado
    } catch (error) {
      console.error("Error fetching publishers:", error);
    }
  };

  fetchEditors();
}, []); // Se ejecuta solo una vez al montar el componente

  

  const onChangeField = e => setField(e ? e.value : null);
  const onChangeIssn = e => setIssn(e.currentTarget.value);
  const onChangeJcrq = e => setJcrq(e ? e.value : null);
  const onChangeSjrq = e => setSjrq(e ? e.value : null);
  const onChangePublisher = e => setPublisher(e ? e.value : null);
  
  

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      color: '#a2a2a2',  // Un gris más oscuro para mayor intensidad
      fontWeight: 600,   // Aumenta el grosor de la fuente
      textAlign: 'left'  // Alinea el placeholder a la izquierda
    }),
    control: (provided) => ({
      ...provided,
      height: '40px',  // Asegura la altura consistente
      textAlign: 'left'  // Alinea el contenido a la izquierda
    }),
    option: (provided) => ({
      ...provided,
      textAlign: 'left'  // Alinea las opciones a la izquierda
    }),
  };

  const clickSearch = async () => {
    setAlertVisible(false); // Oculta el Alert cuando se hace una búsqueda
    let params = {};
    if (issn) params.search = issn;
    if (publisher) params.publisher = publisher;
    if (field) params.field = field;
    if (jcrq) params.jcrq = jcrq;
    if (cuartil) params.cuartil = cuartil;
    if (sjrq) params.sjrq = sjrq;
    if (medida) params.medida = medida;

    try {
      let response = await fetch(backendURL + "/journals?" + new URLSearchParams(params).toString(), {
        method: "GET",
        mode: "cors", // Ya que estás usando CORS, asegúrate de que el backend lo permite
        headers: { 
          "Content-Type": "application/json" 
        }
      });
      
      if (response.ok) {
        let jsonData = await response.json();
        if (jsonData.length === 0) {
          setMessage("La revista que buscas no forma parte de ningún acuerdo transformativo o has introducido mal los criterios de búsqueda.");
          setJournals([]);
        } else {
          setMessage("");
          setJournals(jsonData);
        }
      } else {
        setMessage("Error en la búsqueda. Inténtalo de nuevo.");
        setJournals([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setMessage("Error de red. Verifica la conexión o configura CORS correctamente.");
    }
  }

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default behavior
      clickSearch(); // Call the search function
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      render: (text, record) => (
        <div className="custom-table-title-container">
          <a href={record.url} target="_blank" rel="noopener noreferrer">
            {text}
            <ArrowUpOutlined className="table-link-icon" />
          </a>
          {record.field && (
            <div className="custom-table-subject">
              <span style={{ 
                fontFamily: 'Roboto, sans-serif', 
                fontSize: '16px', 
                fontWeight: 400, 
                color: '#666666' 
              }}>Field: </span>
              <span className="custom-table-field-value">{record.field}</span>
            </div>
          )}
        </div>
      )
    },
    {
      title: "Publisher",
      dataIndex: "publisher",
      render: (text, record) => (
        <div className="custom-table-publisher-container">
          <div className="custom-table-publisher">
            <span className="custom-table-publisher-prefix">Editor: </span>
            <span className="custom-table-publisher-value">{text}</span>
          </div>
        </div>
      )
    },
    {
      title: "APC coverage",
      dataIndex: "apc coverage",
      render: (value, record) => {
        let formattedValue;
        switch (value) {
          case '1':
            formattedValue = '100%';
            break;
          case '0,1':
            formattedValue = '10%';
            break;
          case '0,2':
            formattedValue = '20%';
            break;
          default:
            formattedValue = value;
        }
        const valueStyle = formattedValue === '100%' ? {} : { color: 'red' };
        return (
          <div>
            <div className="custom-table-apc">
              <span className="custom-table-apc-prefix">Cobertura APC: </span>
              <span className="custom-table-apc-value" style={valueStyle}>{formattedValue}</span>
            </div>
          </div>
        );
      }
    },


    {
      title: "eISSN",
      dataIndex: "issn",
      render: text => (
        <span className="custom-table-issn">
          eISSN:  {text}
        </span>
      )
    }
  ];

  const handleSearch = () => {
    onSearch(query, area, quarterJCR, quarterSJR, editor);
    setAlertVisible(false); // Oculta el Alert cuando se realiza la búsqueda desde el botón de búsqueda
  };

  const areas = [
    { value: 'Agriculture, Fisheries & Forestry', label: 'Agriculture, Fisheries & Forestry' },
    { value: 'Biology', label: 'Biology' },
    { value: 'Biomedical Research', label: 'Biomedical Research' },
    { value: 'Built Environment & Design', label: 'Built Environment & Design' },
    { value: 'Chemistry', label: 'Chemistry' },
    { value: 'Clinical Medicine', label: 'Clinical Medicine' },
    { value: 'Communication & Textual Studies', label: 'Communication & Textual Studies' },
    { value: 'Earth & Environmental Sciences', label: 'Earth & Environmental Sciences' },
    { value: 'Economics & Business', label: 'Economics & Business' },
    { value: 'Enabling & Strategic Technologies', label: 'Enabling & Strategic Technologies' },
    { value: 'Engineering', label: 'Engineering' },
    { value: 'Historical Studies', label: 'Historical Studies' },
    { value: 'Information & Communication Technologies', label: 'Information & Communication Technologies' },
    { value: 'Mathematics & Statistics', label: 'Mathematics & Statistics' },
    { value: 'Philosophy & Theology', label: 'Philosophy & Theology' },
    { value: 'Physics & Astronomy', label: 'Physics & Astronomy' },
    { value: 'Psychology & Cognitive Sciences', label: 'Psychology & Cognitive Sciences' },
    { value: 'Public Health & Health Services', label: 'Public Health & Health Services' },
    { value: 'Social Sciences', label: 'Social Sciences' },
    { value: 'Visual & Performing Arts', label: 'Visual & Performing Arts' },
  ].sort((a, b) => a.label.localeCompare(b.label));  // Ordena las áreas alfabéticamente por el label
  

  

  const quarters = [
    { value: 'Q1', label: 'Q1' },
    { value: 'Q2', label: 'Q2' },
    { value: 'Q3', label: 'Q3' },
    { value: 'Q4', label: 'Q4' }
  ];

  const convertToCSV = (data) => {
    const header = columns.map(col => col.title).join(',') + '\n';
    const rows = data.map(row => columns.map(col => row[col.dataIndex]).join(',')).join('\n');
    return header + rows;
  };

  const downloadCSV = () => {
    const csv = convertToCSV(journals);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'journals.csv');
  };

  return (
    <div>
      <Card className="search-box-card" title>
        <div className="search-box-container">
          <div className="search-box-inputs">
            <Input
              placeholder="Buscar revista por título o eISSN"
              onChange={onChangeIssn}
              onKeyDown={handleKeyDown}
              className="search-input"
            />
            <Select
              value={areas.find(a => a.value === area)}
              onChange={onChangeField}
              options={areas}
              className="search-select-area"
              placeholder="Buscar por Área"
              isClearable
              styles={customStyles} // Aplica los estilos personalizados
            />
          </div>
          <div className="search-box-footer">
            <Button
              type="link"
              onClick={() => setShowAdvancedSearch(!showAdvancedSearch)}
              style={{ marginBottom: '10px' }}
            >
              {showAdvancedSearch ? 'Ocultar búsqueda avanzada' : 'Búsqueda avanzada'}
            </Button>
            {showAdvancedSearch && (
              <div className="advanced-search-options">
                
                
                <div className="select-container">
                  <span>Editor</span>
                  <Select
  value={publisher}
  onChange={onChangePublisher}
  options={editors} // Usa los editores obtenidos desde el backend
  className="search-select-advanced"
  isClearable
/>

                </div>
              </div>
            )}
            <Button type="primary" onClick={clickSearch} icon={<SearchOutlined />} size="large">
              Buscar
            </Button>
          </div>
        </div>
      </Card>

      {/* Alerta de "Notas aclaratorias para mejorar la búsqueda" */}
      {alertVisible && (
        <Alert
          message="Notas aclaratorias para mejorar la búsqueda"
          description={
            <ul className="alert-info-list">
              <li>Se puede buscar una revista por el título o por el Online-ISSN.</li>
              <li>También por área temática (categoría Field de la clasificación Science-Metrix).</li>
              <li>En búsqueda avanzada se puede aplicar filtro de Editor</li>
              <li>La base de datos no solo incluye las revistas que forman parte de los AT (con cobertura del 100% de los APCs), sino también aquellas que solo ofrecen un porcentaje de descuento, indicado en rojo.</li>
              <li>La forma más segura de encontrar una revista es buscarla con alguna palabra clave del título.</li>
              <li>En caso de duda, <a href="/journals.xlsx" download className="alert-info-link">descarga aquí</a> la lista completa de revistas elegibles en la que se basa la base de datos de la página web.</li>
            </ul>
          }
          type="info"
          showIcon
          className="alert-custom alert-info"
        />
      )}

      {/* Alerta de "La revista que buscas no forma parte de ningún acuerdo transformativo..." */}
      {message && (
        <Alert
          message={message}
          type="error"
          showIcon
          closable
          className="alert-custom alert-error"  // Clase específica para esta alerta
          style={{ textAlign: 'center', width: '30%', margin: '20px auto' }}
        />
      )}

      {journals.length > 0 && (
        <div style={{ marginTop: '20px' }}>
          <Button
            type="primary"
            onClick={downloadCSV}
            icon={<DownloadOutlined />}
            style={{ float: 'right', marginBottom: '10px' }}
            className="download-csv-button"
          >
            Descargar CSV
          </Button>
          <Table
            columns={columns}
            dataSource={journals}
            theme={{
              token: {
                colorLink: 'black',
                colorTextDescription: 'rgb(24, 24, 0)'
              },
            }}
            className="custom-table"
          />
        </div>
      )}
    </div>
  );
};

export default SearchComponent;












